import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Todo } from '../App';

interface SortableTodoItemProps {
  todo: Todo;
  onToggle: (id: string) => void;
  onUpdate: (id: string, text: string) => void;
  onDelete: (id: string) => void;
}

export const SortableTodoItem: React.FC<SortableTodoItemProps> = ({
  todo,
  onToggle,
  onUpdate,
  onDelete
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: todo.id });

  // Use the dnd-kit provided utilities for transformations
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : undefined,
  };

  const handleEdit = () => {
    const newText = prompt('Edit todo:', todo.text);
    if (newText !== null && newText.trim() !== '') {
      onUpdate(todo.id, newText.trim());
    }
  };

  const handleDelete = () => {
    if (confirm('Are you sure you want to delete this todo?')) {
      onDelete(todo.id);
    }
  };

  // Format date for readability
  const formatDate = (dateString: string | null) => {
    if (!dateString) return null;
    
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
  };

  const completionInfo = todo.completed && todo.completed_at && todo.completed_by ? (
    <div className="todo-completion-info">
      <span>Completed by {todo.completed_by} on {formatDate(todo.completed_at)}</span>
    </div>
  ) : null;

  return (
    <li
      ref={setNodeRef}
      style={style}
      className={`todo-item ${todo.completed ? 'completed' : ''}`}
      {...attributes}
    >
      <div 
        className="drag-handle" 
        {...listeners}
      >
        <i className="fas fa-grip-lines"></i>
      </div>
      
      <div className="todo-content">
        <div className="todo-main">
          <input
            type="checkbox"
            className="todo-checkbox"
            checked={todo.completed}
            onChange={() => onToggle(todo.id)}
          />
          
          <span className="todo-text">{todo.text}</span>
          
          <div className="todo-actions">
            <button 
              className="todo-edit"
              onClick={handleEdit}
            >
              <i className="fas fa-edit"></i>
            </button>
            <button 
              className="todo-delete"
              onClick={handleDelete}
            >
              <i className="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
        {completionInfo}
      </div>
    </li>
  );
}; 